import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=2b93bb97&scoped=true&"
import script from "./Notices.vue?vue&type=script&lang=js&"
export * from "./Notices.vue?vue&type=script&lang=js&"
import style0 from "./Notices.vue?vue&type=style&index=0&id=2b93bb97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b93bb97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/ctg-code/qihuibao-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
